import {fetchDelete, fetchGet, fetchPatch, fetchPost} from "./util";

export const getEventsOverview = (query) => {
    return fetchGet(`/events/overview?${query}`).then((res) => res);
};

export const getCasesOverview = (query) => {
    if (query === undefined) {
        return fetchGet(`/events/cases-overview`).then((res) => res)
    }
    return fetchGet(`/events/cases-overview?${query}`).then((res) => res);
};

export const getResaleOverview = (query) => {
    return fetchGet(`/events/resale-overview?${query}`).then((res) => res);
};

export const updateAttendanceStatus = (data) => {
    return fetchPatch(`/events/person/attendance`, data.obj).then(res => res)
};

export const updateAttendanceVerification = (data) => {
    return fetchPatch(`/events/person/attendance-verification`, data).then(res => res)
};

export const updateSendoutEmail = (data) => {
    return fetchPatch(`/notifications`, data.obj).then(res => res)
};

export const getPersonPurchases = (id) => {
    return fetchGet(`/persons/${id}/purchases`).then(res => res)
};

export const getPersonOpportunities = (id) => {
    return fetchGet(`/persons/${id}/opportunities`).then(res => res)
};

export const getPersonOpenOpportunity = (id) => {
    return fetchGet(`/persons/${id}/opportunities/open`).then(res => res)
};

export const updatePersonStage = (data) => {
    return fetchPatch(`/opportunities/${data.opportunityId}/stages/${data.stageId}`, {}).then(res => res)
}

export const getPersonHistory = ({person_id, query, isNetworkDirector}) => {
    return fetchGet(`/persons/${person_id}/history?type=${query}&nd=${isNetworkDirector ? 1 : 0}`).then(res => res);
};

export const getParticipantDetails = ({event_id, participant_id}) => {
    return fetchGet(`/events/${event_id}/participants/${participant_id}/details`).then(res => res);
};

export const getEventDetails = (event_id) => {
    return fetchGet(`/events/${event_id}/details`).then(res => res);
};

export const getNoteTypes = () => {
    return fetchGet(`/note-types`).then(res => res);
};

export const addHistoryLog = (data) => {
    return fetchPost(`/persons/${data.id}/log`, data.obj).then(res => res);
};

export const updateNotes = (data) => {
    return fetchPatch(`/events/notes`, data.obj).then(res => res);
};

export const updateEmail = (data) => {
    return fetchPost(`/events/email-invitations`, data.obj, true).then(res => res);
};

export const deleteAttachedFile = (data) => {
    return fetchDelete(`/events/file/${data.upload_id}/${data.event_id}/${data.type}`, {}).then(res => res);
};

export const getNetworkDirectors = (_data) => {
    return fetchGet(`/events/network-directors`).then(res => res);
};

export const getEventsOverviewUsers = (_data) => {
    return fetchGet(`/events/sales-reps`).then(res => res);
};

export const pauseCase = (data) => {
    return fetchPost(`/cases/pause`, data.data).then(res => res)
}

export const registerOnGoingCase = (data) => {
    return fetchPost(`/cases/ongoing`, data.data).then(res => res)
}

export const resolveCase = (data) => {
    return fetchPatch(`/cases/resolve/${data.case_id}`, data.data).then(res => res)
}

export const getSpecialCaseDetails = (purchase_id) => {
    return fetchGet(`/cases/purchases/${purchase_id}`).then(res => res)
}

export const getPendingCases = () => {
    return fetchGet(`/cases/stats`).then((res) => res);
};

export const getCaseUsersList = (data) => {
    return fetchGet(`/cases/${data.caseName}/user-list?cap_id=${data.capabilityId}`).then((res) => res);
};

export const getEventMembers = (event_id) => {
    return fetchGet(`/events/participants/${event_id}`).then((res) => res);
};

export const caseDecline = (data) => {
    return fetchPatch(`/cases/decline/${data.case_id}`).then((res) => res);
}
export const getCasesEventsOverview = ({product_id, purchase_id}) => {
    return fetchGet(`/events/casesoverview/${product_id}/${purchase_id}/details`);
};

export const updateAssignee = (data) => {
    return fetchPatch(`/cases/reassign/${data.caseId}`, data).then((res) => res);
}

export const pendingCaseDetails = (purchase_id) => {
    return fetchGet(`/cases/purchase/${purchase_id}/details`).then(res => res)
}

export const saveGroupEmail = (data) => {
    return fetchPost(`/events/${data.event_id}/group-emails`, data).then(res => res);
}

export const getGroupEmails = (event_id) => {
    return fetchGet(`/events/${event_id}/group-emails`).then(res => res);
}

export const deleteGroupEmail = (event_id, event_group_email_id) => {
    return fetchDelete(`/events/${event_id}/group-emails/${event_group_email_id}`).then(res => res);
}

export const updateGroupEmail = (event_id, event_group_email_id, data) => {
    return fetchPatch(`/events/${event_id}/group-emails/${event_group_email_id}`, data).then(res => res);
}

export const createOutboundSender = ({event_id, data}) => {
    return fetchPost(`/events/${event_id}/outbound/sender`, data).then(res => res)
}

export const getPersonChangeGroupVisibility = (person_id) => {
    return fetchGet(`/persons/group-changes/${person_id}/visibility`).then(res => res)
}
